var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    { class: _vm.wrapClasses },
    [
      _c("span", { class: _vm.radioClasses }, [
        _c("span", { class: _vm.innerClasses }),
        _c("input", {
          class: _vm.inputClasses,
          attrs: { type: "radio", disabled: _vm.disabled, name: _vm.groupName },
          domProps: { checked: _vm.currentValue },
          on: { change: _vm.change, focus: _vm.onFocus, blur: _vm.onBlur }
        })
      ]),
      _vm._t(
        "default",
        function() {
          return [_vm._v(_vm._s(_vm.label))]
        },
        { currentValue: _vm.currentValue }
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4902bb3c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4902bb3c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Radio/Radio.vue
// module id = sIc5
// module chunks = 0 3